module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/139-venezuela-b32412eaf5738b043a19eb1744de3493.svg";